import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Alert, AlertService } from '@michelin/theme';
import { AutomakerDto } from 'src/app/shared/models/automaker/automaker-dto';
import { AutomakerService } from 'src/app/shared/services/automaker/automaker.service';
import { DealershipService } from 'src/app/shared/services/dealership/dealership.service';

@Component({
    selector: 'app-export-dealership',
    templateUrl: './export-dealership.component.html',
    standalone: false
})
export class ExportDealershipComponent implements OnInit {
  loading = false;
  automakers: AutomakerDto[] = [];

  formExport: FormGroup = null;

  constructor(
    private readonly dealershipService: DealershipService,
    private readonly automakerService: AutomakerService,
    private readonly alertService: AlertService,
    private readonly formBuilder: FormBuilder
  ) {
    this.formExport = this.formBuilder.group({
      automaker: ['', Validators.required],
      status: ['AIF', Validators.required]
    });
  }

  get automaker(): FormControl {
    return this.formExport?.get('automaker') as FormControl;
  }

  companyDisplayName(data: any) {
    return data.company?.tradeName;
  }

  submitForm() {
    this.loading = true;

    this.dealershipService.exportExcel(this.formExport.value.automaker?.id, this.formExport.value.status).subscribe({
      next: (response) => {
        const blob = new Blob([response.body!], { type: response.headers.get('Content-Type') || 'application/octet-stream' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        const nomeBase = this.getFileNameFromHeader(response.headers) || 'CarDealer_Cadastro_CCs';
        const timestamp = this.getFormatedDateTime();
        a.download = `${nomeBase}_${timestamp}.xlsx`;
        a.click();
        window.URL.revokeObjectURL(url);
      },
      complete: () => {
        this.loading = false;
      }
    });
  }

  ngOnInit() {
    this.formExport = this.formBuilder.group({
      automaker: ['', Validators.required],
      status: ['AIF', Validators.required]
    });

    this.loading = true;

    this.automakerService
      .findAll()
      .subscribe({
        next: (result) => (this.automakers = result),
        error: () => this.alertService.showAlert({ type: 'critical', title: 'Ocorreu um erro ao recuperar as informações' } as Alert)
      })
      .add(() => (this.loading = false));
  }

  private getFileNameFromHeader(headers: any): string | null {
    const contentDisposition = headers.get('Content-Disposition');
    if (!contentDisposition) return null;

    const matches = /filename="([^"]+)"/.exec(contentDisposition);
    return matches && matches[1] ? matches[1] : null;
  }

  private getFormatedDateTime(): string {
    const agora = new Date();
    const data = agora.toISOString().split('T')[0];
    const hora = agora.getHours().toString().padStart(2, '0') + agora.getMinutes().toString().padStart(2, '0');
    return `${data}_${hora}`;
  }
}
